import React from "react";
import "../styles/team.css";
import leader from "../assets/co6-leader.png";
import director from '../assets/horecaleader.png';

const Team = () => {
  return (
    <div className="meetleader">
      <h4
        style={{
          marginTop: "1.5rem",
          marginBottom: "1.6rem",
          textAlign: "center",
          color: "#FFD52B",
          fontSize: "1.2rem",
        }}
      >
        Meet Our Leaders
      </h4>
      <hr></hr>
      <div style={{ padding: "2rem" }}>
        <h1
          style={{
            textAlign: "center",
            color: "white",
            fontSize: "2.6rem",
            fontWeight: "700",
          }}
        >
          Behind Every Innovation is a Visionary Team
        </h1>

        <div
          className="meetleader-container"
          style={{ display: "flex", marginTop: "3rem" }}>
          <div className="meetleader-box1">
            <img
            className="leader-pic"
              src={leader}
              width="70%"
              height="100%"
              style={{ objectFit: "cover", borderRadius: "5px", borderRadius:'6px',objectPosition:'top' }}
            ></img>
          </div>
          <div className="meetleader-box2" style={{ position: "relative" }}>
            <h6>Mohamed Jahangir Ghouse</h6>
            <p style={{ fontSize: "0.8rem", color: "#FFD52B" }}>
              Managing Director
            </p>
            <p style={{ color: "white" }}>
              A pioneer in robotics and automation, Jahangir has built CO6 into
              a global leader with a commitment to innovation and quality. His
              vision is to seamlessly integrate robotics into every facet of
              industry and daily life.
            </p>
            <h6>Quote</h6>
            <p
              style={{
                fontSize: "0.9rem",
                color: "#FFD52B",
                fontStyle: "italic",
              }}
            >
              “The future of work is a productive interplay<br></br> between
              humans and robots.”
            </p>
          </div>
        </div>

        
      </div>
      <div className="team-container">
      <h2 style={{textAlign:'center' , fontWeight:'600', fontSize:'2.5rem', margin:'2.5rem 0rem'}}>Our <span style={{color:'#FFD52B'}}>Team</span></h2>

      <div className=" team-member">
      <div className="row clo-12 col-md-10" >
            <div className="col-12 col-md-2 ">
            <img
            className="team-director"
              src={director}
              width="100%"
              height="125px"
              style={{ objectFit: "cover", borderRadius: "5px", borderRadius:'6px',objectPosition:'top' }}
            ></img>
            </div>
            <div className="col-12 col-md-10 ">
                <h4 style={{fontWeight:'600'}}>Tuan Tran Thanh</h4>
                <p style={{color:'#FFD52B',fontSize:'0.9rem',marginBottom:'0.5rem'}}>Director of Engineering</p>
                <p style={{color:'white',fontSize:'0.9rem'}} >Tuan Tran Thanh combines engineering excellence with strategic vision, overseeing the development of advanced robotic systems that meet the demands of industries worldwide.</p>
                
            </div>
        </div>
        
      </div>
      <div className=" team-member">
      <div className="row clo-12 col-md-10 sol-col-rev" >
            
            <div className="col-12 col-md-10 ">
                <h4 style={{fontWeight:'600'}}>Wesley Tang Wymer</h4>
                <p style={{color:'#FFD52B',fontSize:'0.9rem',marginBottom:'0.5rem'}}>Associate Director of Engineering</p>
                <p style={{color:'white',fontSize:'0.9rem'}} >Wesley Tang Wymer, Associate Director of Engineering at CO6 Robotic Systems, specializes in developing innovative robotic solutions. His expertise in engineering drives impactful & future-focused automation.</p>
                
            </div>
            <div className="col-12 col-md-2 ">
               <h1 style={{fontWeight:'600',color:'#FFD52B'}}>01</h1>
            </div>
        </div>
        
      </div>
      <div className=" team-member">
      <div className="row clo-12 col-md-10" >
            <div className="col-12 col-md-2 ">
               <h1 style={{fontWeight:'600',color:'#FFD52B'}}>02</h1>
            </div>
            <div className="col-12 col-md-10 ">
                <h4 style={{fontWeight:'600'}}>Jon Carroll</h4>
                <p style={{color:'#FFD52B',fontSize:'0.9rem',marginBottom:'0.5rem'}}>Director of Marketing</p>
                <p style={{color:'white',fontSize:'0.9rem'}} >Jon Carroll's expertise in business strategy and marketing has helped position Co6 Robotic Systems as an industry leader. He drives global marketing initiatives to expand the brand.</p>
                
            </div>
        </div>
        
      </div>
      <div className=" team-member">
      <div className="row clo-12 col-md-10 sol-col-rev" >
            
            <div className="col-12 col-md-10 ">
                <h4 style={{fontWeight:'600'}}>John Ives</h4>
                <p style={{color:'#FFD52B',fontSize:'0.9rem',marginBottom:'0.5rem'}}>Director of Finance</p>
                <p style={{color:'white',fontSize:'0.9rem'}} >John Ives ensures financial sustainability while overseeing strategic investments and global expansion initiatives that continue to position Co6 as an innovation leader.</p>
                
            </div>
            <div className="col-12 col-md-2 ">
               <h1 style={{fontWeight:'600',color:'#FFD52B'}}>03</h1>
            </div>
        </div>
        
      </div>
      

      </div>


    </div>
  );
};

export default Team;
